import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from "react"

type PageTitleContextValue = {
  title: string
  setTitle: (title: string) => void
}

const PageTitleContext = createContext<PageTitleContextValue | null>(null)

type PageTitleProviderProps = {
  children: ReactNode
  defaultTitle?: string
}

export function PageTitleProvider({
  children,
  defaultTitle = "",
}: PageTitleProviderProps) {
  const [title, setTitle] = useState(defaultTitle)

  useEffect(() => {
    document.title = `Egab | ${title}`
  }, [title])

  return (
    <PageTitleContext.Provider value={{ title, setTitle }}>
      {children}
    </PageTitleContext.Provider>
  )
}

export function usePageTitle() {
  const context = useContext(PageTitleContext)

  if (!context) {
    throw new Error("usePageTitle must be used inside PageTitleProvider")
  }

  return context
}
